import { RobotOutlined, UserOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';

export interface AIChatBubbleProps {
  role: 'user' | 'assistant';
  children: ReactNode;
}

export function AIChatBubble({ role, children }: AIChatBubbleProps) {
  const isUser = role === 'user';
  return (
    <div
      style={{
        display: 'flex',
        gap: 10,
        marginBottom: 16,
        flexDirection: isUser ? 'row-reverse' : 'row',
        alignItems: 'flex-start',
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: isUser ? '#1677ff' : '#722ed1',
          color: '#fff',
          flexShrink: 0,
        }}
        aria-hidden
      >
        {isUser ? <UserOutlined /> : <RobotOutlined />}
      </div>
      <div className={isUser ? 'ai-chat-bubble-user' : 'ai-chat-bubble-assistant'}>{children}</div>
    </div>
  );
}
